'use client';

import { IconPlaneDeparture } from '@actr/icons/plane-departure';
import { IconQuestionCircle } from '@actr/icons/question-circle';
import { IconRubleCircle } from '@actr/icons/ruble-circle';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import React, { memo } from 'react';

import * as Styled from './style.css';

const ServiceAdvantages: React.FC = () => (
  <ContentBlock id="advantages">
    <Text tagName="h3" font="title.x2l">
      Преимущества
    </Text>
    <div className={Styled.Advantages}>
      <ContentBlock
        className={Styled.Advantage}
        tagProps={{ itemScope: true, itemType: 'https://schema.org/Claim' }}>
        <IconPlaneDeparture className={Styled.Icons} />
        <Text font="paragraph.m" tagProps={{ itemProp: 'description' }}>
          Мы предлагаем простой и интуитивно понятный интерфейс, который позволяет быстро находить лучшие рейсы по любым направлениям
        </Text>
      </ContentBlock>
      <ContentBlock
        className={Styled.Advantage}
        tagProps={{ itemScope: true, itemType: 'https://schema.org/Claim' }}>
        <IconRubleCircle className={Styled.Icons} />
        <Text font="paragraph.m" tagProps={{ itemProp: 'description' }}>
          Мы работаем напрямую с авиакомпаниями и поставщиками, чтобы предлагать вам самые низкие цены на билеты
        </Text>
      </ContentBlock>
      <ContentBlock
        className={Styled.Advantage}
        tagProps={{ itemScope: true, itemType: 'https://schema.org/Claim' }}>
        <IconQuestionCircle className={Styled.Icons} />
        <Text font="paragraph.m" tagProps={{ itemProp: 'description' }}>
          Наша служба поддержки всегда готова помочь.
          Если у вас возникнут вопросы или проблемы с бронированием, мы оперативно предоставим решение
        </Text>
      </ContentBlock>
    </div>
  </ContentBlock>
);

export default memo(ServiceAdvantages);
